// This icon file is generated automatically.
var PPicCenterOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.88 11.38H.12a.13.13 0 00-.12.12v.88c0 .06.06.12.13.12h13.74c.07 0 .13-.06.13-.13v-.87a.13.13 0 00-.13-.13zm0-9.88H.12a.13.13 0 00-.12.13v.87c0 .07.06.13.13.13h13.74c.07 0 .13-.06.13-.13v-.88a.13.13 0 00-.13-.12zm-1.63 7.81c.14 0 .25-.11.25-.25V4.94a.25.25 0 00-.25-.25H1.75a.25.25 0 00-.25.25v4.12c0 .14.11.25.25.25h10.5zm-9.63-3.5h8.75V8.2H2.63V5.8z", "fill-rule": "nonzero" } }] }, "name": "p-pic-center", "theme": "outlined" };
export default PPicCenterOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPicCenterOutlined.js
// module id = 3528
// module chunks = 0